const carouselItems = [
  {
    title: '顶流偶像塌房：从神坛到泥潭的72小时',
    desc: '完整时间线还原事件始末',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20with%20fallen%20microphone%20and%20scattered%20rose%20petals%2C%20spotlight%20dimmed%2C%20neon%20green%20accent%20light%2C%20mysterious%20atmosphere%2C%20high%20contrast%20editorial%20photography%2C%20celebrity%20scandal%20theme%2C%20cinematic%20lighting&width=800&height=1067&seq=carousel-01&orientation=portrait',
  },
  {
    title: '直播圈大地震：头部主播集体被查内幕',
    desc: '多位千万级主播涉嫌偷税',
    img: 'https://readdy.ai/api/search-image?query=Empty%20live%20streaming%20studio%20with%20ring%20lights%20off%2C%20abandoned%20products%20on%20table%2C%20dark%20dramatic%20shadows%2C%20neon%20green%20screen%20reflection%2C%20editorial%20quality%2C%20high%20contrast%2C%20mysterious%20mood%2C%20commercial%20scandal%20aesthetic&width=800&height=1067&seq=carousel-02&orientation=portrait',
  },
  {
    title: '短视频圈连环瓜：从抄袭到人设崩塌',
    desc: '一个月内5位大V翻车实录',
    img: 'https://readdy.ai/api/search-image?query=Multiple%20smartphones%20scattered%20on%20dark%20surface%20displaying%20static%20noise%2C%20dramatic%20overhead%20lighting%2C%20neon%20green%20glow%20from%20one%20screen%2C%20editorial%20photography%2C%20high%20contrast%2C%20social%20media%20drama%20theme&width=800&height=1067&seq=carousel-03&orientation=portrait',
  },
  {
    title: '知识付费圈的虚假繁荣：揭秘割韭菜套路',
    desc: '溢价100倍的知识产品真相',
    img: 'https://readdy.ai/api/search-image?query=Stack%20of%20fake%20certificates%20and%20diplomas%20on%20dark%20desk%2C%20dramatic%20lighting%20from%20side%2C%20neon%20green%20highlighter%20marks%2C%20editorial%20quality%2C%20high%20contrast%2C%20academic%20fraud%20aesthetic%2C%20dark%20moody&width=800&height=1067&seq=carousel-04&orientation=portrait',
  },
  {
    title: '网红MCN吸血合同曝光：博主成现代包身工',
    desc: '37页合同暗藏21个陷阱条款',
    img: 'https://readdy.ai/api/search-image?query=Shredded%20contract%20papers%20with%20red%20stamps%20on%20dark%20floor%2C%20dramatic%20overhead%20lighting%2C%20neon%20green%20pen%20accent%2C%20editorial%20photography%2C%20high%20contrast%2C%20corporate%20exploitation%20theme%2C%20dark%20cinematic&width=800&height=1067&seq=carousel-05&orientation=portrait',
  },
  {
    title: '电竞圈至暗时刻：假赛产业链完全起底',
    desc: '从选手到管理层的利益链',
    img: 'https://readdy.ai/api/search-image?query=Gaming%20keyboard%20shattered%20on%20dark%20floor%2C%20dramatic%20lighting%2C%20neon%20green%20LED%20reflections%2C%20editorial%20photography%2C%20high%20contrast%2C%20esports%20scandal%20aesthetic%2C%20dark%20moody%20atmosphere&width=800&height=1067&seq=carousel-06&orientation=portrait',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-20 md:py-28 bg-background-700">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 mb-4 text-center">
          焦点轮播：近期大瓜直击 🍉
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-14">
          左右滑动查看更多精彩爆料
        </p>

        <div className="flex gap-5 overflow-x-auto pb-6 scrollbar-hide">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex-shrink-0 rounded-2xl overflow-hidden relative cursor-pointer group transition-all duration-500 ${
                idx === 0 ? 'w-[320px] md:w-[440px]' : 'w-[240px] md:w-[320px]'
              }`}
              style={{ aspectRatio: '3/4' }}
            >
              <img
                src={item.img}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/10 to-transparent"></div>

              <div className="absolute bottom-5 left-5 right-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-50 font-heading leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-300 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}